import React, { useState, useEffect } from "react";
import { Register } from "../components/register";
import { UpdateUser } from "../components/updateUser";
import { ResetUserPassword } from "../components/resetUserPassword";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import './App.css';

function Admin() {
  const [loginStatus, setLoginStatus] = useState(false);
  const [createNewUser, setCreateNewUser] = useState(false);
  const [updateUser, setUpdateUser] = useState(false);
  const [resetUserPass, setResettingUserPass] = useState(false);

  useEffect(() => {
    setLoginStatus(Boolean(localStorage.getItem('token')));
  }, []);

  const isAdmin = localStorage.getItem('adminFunctions') === '1';

  // AIMS pattern: an action-tile grid; each item opens as a modal dialog.
  const adminMenu = [
    { label: 'Create A New User', onClick: () => setCreateNewUser(true) },
    { label: 'Update User', onClick: () => setUpdateUser(true) },
    { label: 'Reset User Password', onClick: () => setResettingUserPass(true) },
  ];

  return (
    <div className="admin">
      {loginStatus && isAdmin ? (
        <Box sx={{ maxWidth: 760, mx: 'auto', width: '100%', mt: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>Admin</Typography>
          <Typography variant="body2" sx={{ color: 'var(--muted)', mb: 2 }}>
            Create, update or reset a user account.
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.5 }}>
            {adminMenu.map((m) => (
              <Button
                key={m.label}
                variant="outlined"
                onClick={m.onClick}
                sx={{
                  justifyContent: 'flex-start',
                  fontSize: 14,
                  py: 1.5,
                  px: 2,
                  background: 'var(--surface)',
                  borderColor: 'var(--border)',
                  boxShadow: 'var(--shadow-sm)',
                }}
              >
                {m.label}
              </Button>
            ))}
          </Box>
        </Box>
      ) : null}

      {/* Each component renders its own pinned modal (title + scroll + actions). */}
      {isAdmin && loginStatus && createNewUser && <Register onClose={() => setCreateNewUser(false)} />}
      {isAdmin && loginStatus && updateUser && <UpdateUser onClose={() => setUpdateUser(false)} />}
      {isAdmin && loginStatus && resetUserPass && <ResetUserPassword onClose={() => setResettingUserPass(false)} />}
    </div>
  );
}

export default Admin;
